/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Openai_DescriptionInputs */

const en_admin_settings_groups_openai_description = /** @type {(inputs: Admin_Settings_Groups_Openai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI (or compatible) API`)
};

/**
* | output |
* | --- |
* | "OpenAI (or compatible) API" |
*
* @param {Admin_Settings_Groups_Openai_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_openai_description = /** @type {((inputs?: Admin_Settings_Groups_Openai_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Openai_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_openai_description(inputs)
});
export { admin_settings_groups_openai_description as "admin.settings.groups.openai.description" }